<script>
  import { createEventDispatcher } from "svelte";

  const dispatch = createEventDispatcher();

  function passProdKey() {
    dispatch("onProductSelected", {
      key: key
    });
  }
  export let key;
  export let name;
  export let imgPath;
  export let price;
  export let desc;
</script>

<style>
  #card {
    width: 150px;
    height: 200px;
    border: 1px solid rgb(255, 38, 0);
    border-radius: 12px;
    background-color: rgb(255, 229, 197);
    padding: 5px;
    margin: 12px;
    cursor: pointer;
    -webkit-box-shadow: 4px 6px 23px -7px rgba(0, 0, 0, 1);
    -moz-box-shadow: 4px 6px 23px -7px rgba(0, 0, 0, 1);
    box-shadow: 4px 6px 23px -7px rgba(0, 0, 0, 1);
  }

  h3 {
    font-size: 1.3em;
    text-align: center;
    padding: 3px;
    margin: 0 auto;
    color: rgb(245, 60, 4);
    border: 1px solid rgb(255, 115, 0);
    border-radius: 8px;
    text-align: center;
    background-color: rgb(255, 244, 140);
  }
  h5 {
    font-size: 0.7em;
    color: darkmagenta;
  }
  img {
    display: block;
    width: 80%;
    height: 50%;
    border-radius: 15px;
    margin: 12px auto;
  }
  span {
    display: block;
    font-size: 1.2em;
    font-weight: bolder;
    width: 90%;
    color: #fff;
    text-align: center;
    background-color: rgb(255, 131, 94);
    border-radius: 18px;
    margin: auto;
  }
</style>

<div id="card" on:click={passProdKey} on:onProductSelected>
  <h3>{name}</h3>
  <img src={imgPath} alt={desc} />
  <h5>{desc}</h5>
  <span>{price}</span>
</div>
